import React, { useEffect, useState } from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";
import axios from "axios";

// Register Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend, Title);

const UsersOverviewOne = () => {
  const BaseUrl = process.env.REACT_APP_API;

  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${BaseUrl}/binance/funding-wallet`);
        const data = response?.data?.balances;

        if (!data || data.length === 0) {
          console.error("No data available or data is null.");
          return;
        }

        const filteredData = data
          .filter((item) => parseFloat(item.balanceInUSD) > 0)
          .map((item) => ({
            label: item.walletName,
            value: parseFloat(item.balanceInUSD),
          }));

        if (filteredData.length === 0) {
          console.error("No valid wallets to display.");
          return;
        }

        const labels = filteredData.map((item) => item.label);
        const values = filteredData.map((item) => item.value);

        setChartData({
          labels: labels,
          datasets: [
            {
              data: values,
              backgroundColor: [
                "#FF6384",
                "#36A2EB",
                "#FFCE56",
                "#4BC0C0",
                "#9966FF",
                "#FF9F40",
                "#00A950",
              ],
              hoverBackgroundColor: [
                "#FF6384",
                "#36A2EB",
                "#FFCE56",
                "#4BC0C0",
                "#9966FF",
                "#FF9F40",
                "#00A950",
              ],
            },
          ],
        });
      } catch (error) {
        console.error("Error fetching wallet balances:", error);
      }
    };

    fetchData();

    const intervalId = setInterval(fetchData, 60000);

    return () => clearInterval(intervalId);
  }, [BaseUrl]);

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
         tooltip: {
        callbacks: {
          label: (tooltipItem) => {
            const dataset = tooltipItem.dataset.data;
            const value = dataset[tooltipItem.dataIndex];
            const total = dataset.reduce((sum, val) => sum + val, 0);
            const percentage = ((value / total) * 100).toFixed(2);
            return `${value} (${percentage}%)`;
          },
        },
      },
    },
  };

  return (
        <div className="col-xxl-4 col-xl-6">
      <div className="card h-100 radius-8 border-0 overflow-hidden">
        <div className="card-body p-24">
          <div className="d-flex align-items-center text-lg flex-wrap gap-2 justify-content-between">
          </div>
          <h6 style={{ textAlign: "center", marginBottom: "10px" }}>
        Wallet Balances
      </h6>
          {chartData ? (
            <Pie className="text-lg"data={chartData} options={chartOptions} />
          ) : (
            <p>Loading chart data...</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default UsersOverviewOne;
